import { render, staticRenderFns } from "./quick-scroll.vue?vue&type=template&id=04ec10fb&"
import script from "./quick-scroll.vue?vue&type=script&lang=ts&"
export * from "./quick-scroll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports